import * as yup from "yup"

const reminder_validation = {
  memo: yup.string().label("Memo").required(),
  promise_date: yup.string().label("Promised date").required(),
  transaction_date: yup.string().label("Date").required()
}
export const detail_bill_service_values = yup.object().shape({
  product_id: yup.string().label("Account").required(),
  description: yup.string().label("Description"),
  quantity_order: yup.number().label("Qty").min(1).required(),
  quantity_unit: yup.string().label("Unit").required(),
  price_bill: yup.number().optional().nullable(),
  discount: yup.number().label("Discount").required(),
  total: yup.number().optional().nullable(),
  project_id: yup.string().label("Jobs").required(),
  tax_id: yup.string().label("Tax").required(),
  tax_rate: yup.string().optional(),
  total_tax_paid: yup.number().optional().nullable(),
  mr_unit_id: yup.string().optional(), 
})
export const bill_service_values = yup.object().shape({
  trx_code: yup.string().optional(),
  approval_status: yup.number().optional().nullable(),
  vendor_id: yup.string().label("Supplier").required(),
  vendor_name: yup.string().optional(),
  location_id: yup.string().label("Location").required(),
  address: yup.string().label("Address").optional(),
  memo: yup.string().label("Memo").required(),
  transaction_date: yup.string().label("Date").required(),
  referensi: yup.string().label("Referensi").required(),
  freight: yup.number().label("Freight").required(),
  promise_date: yup.string().label("Promised date").required(),
  reminder: yup.object().nullable().shape(reminder_validation),
  details: yup.array().label("Bill service detail").min(1).required().of(detail_bill_service_values),
})

export type BillServiceValues = yup.InferType<typeof bill_service_values>
export type DetailBillServiceValues = yup.InferType<typeof detail_bill_service_values>